import moment from 'moment';
import { Colors } from 'modules/theme';

export const getAlertVisuals = type => {
  switch (type) {
    case 'warning':
      return {
        label: 'Critical',
        borderColor: '#ef4444',
        iconColor: '#ef4444',
        badgeBackground: '#fef2f2',
        badgeColor: '#b91c1c',
        iconBackground: '#fee2e2',
        icon: 'exclamation-circle',
      };
    case 'alert':
      return {
        label: 'Alert',
        borderColor: Colors.orange,
        iconColor: Colors.orange,
        badgeBackground: '#fff7ed',
        badgeColor: '#c2410c',
        iconBackground: '#ffedd5',
        icon: 'exclamation-circle',
      };
    case 'success':
      return {
        label: 'Resolved',
        borderColor: Colors.green,
        iconColor: Colors.green,
        badgeBackground: '#f0fdf4',
        badgeColor: '#15803d',
        iconBackground: '#dcfce7',
        icon: 'check-circle',
      };
    default:
      return {
        label: 'Info',
        borderColor: '#94a3b8',
        iconColor: '#64748b',
        badgeBackground: '#f8fafc',
        badgeColor: '#475569',
        iconBackground: '#f1f5f9',
        icon: 'info-circle',
      };
  }
};

export const formatAlertTimestamp = createdAt => {
  const timestamp = moment(createdAt);
  if (!timestamp.isValid()) {
    return { relative: '', absolute: '' };
  }

  return {
    relative: timestamp.fromNow(),
    absolute: timestamp.format('MMM D, YYYY · h:mm A'),
  };
};
